module.exports = __webpack_public_path__ + "static/media/searchinput.622bd4f0.svg";